/*
 * Business Hours checks
 * TODO
 *  - holidays
 *  - special days
 * */

// Test logger for both node and browser
import { getLogger } from '../common/loggerEx.js';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData.js';
import timezone from 'dayjs/plugin/timezone.js';

const logger = getLogger('BUSHRS');
dayjs.extend(localeData);
dayjs.extend(timezone);

export const defaultBusinessHours = {
  wd: {
    0: { open: false, start: '09:00', end: '17:00' },
    1: { open: true, start: '09:00', end: '17:00' },
    2: { open: true, start: '09:00', end: '17:00' },
    3: { open: true, start: '09:00', end: '17:00' },
    4: { open: true, start: '09:00', end: '17:00' },
    5: { open: true, start: '09:00', end: '17:00' },
    6: { open: false, start: '09:00', end: '17:00' },
  },
  tz: 'America/Los_Angeles',
};

export class BusinessHours {
  constructor() {
    // Noop
  }

  // Validate business hours data
  static isValid(hours) {
    if (!('wd' in hours) || !('tz' in hours)) {
      //logger.warn({ hours }, `Business hours invalid`);
      return false;
    }
    // todo more checks
    return true;
  }

  // hour must be in form hh:mm (09:00)
  // returns minute of the day (hh*60+mm), or -1 if hour is in wrong format
  static hourToDayMinute(hour) {
    if (!(typeof hour === 'string')) {
      return -1;
    }
    const hp = hour.split(':');
    if (!Array.isArray(hp) || hp.length !== 2) {
      return -1;
    }
    const h = parseInt(hp[0]);
    const m = parseInt(hp[1]);
    if (h < 0 || h > 23 || m < 0 || m > 59) {
      return -1;
    }
    return h * 60 + m;
  }
  // Check for open / closed per provided business hours data
  static isOpen(hours, defaultOpen = false, timestamp = null) {
    if (!BusinessHours.isValid(hours)) {
      return { valid: false, open: defaultOpen };
    }
    const ts = timestamp ? timestamp : Date.now();
    const localDate = dayjs(ts).tz(hours.tz);
    const localDay = localDate.day();
    const dayHours = hours?.wd[localDay] || null;
    if (!dayHours) {
      logger.warn({ hours }, `BUSINESS HOURS(${localDate.format()}): DAY(${localDay}): no day data => open=${defaultOpen}`);
      return { valid: false, open: defaultOpen };
    }
    const dayOpen = dayHours?.open || defaultOpen;
    if (!dayOpen) {
      logger.info({ hours }, `BUSINESS HOURS(${localDate.format()}): DAY(${localDay}): closed => open=false`);
      return { valid: true, open: false };
    }
    const dayStart = dayHours?.start || null;
    const dayEnd = dayHours?.end || null;
    if (!dayStart || !dayEnd || !(typeof dayStart === 'string') || !(typeof dayEnd === 'string')) {
      logger.warn({ hours }, `BUSINESS HOURS(${localDate.format()}): DAY(${localDay}): wrong day data => open=${defaultOpen}`);
      return { valid: false, open: defaultOpen };
    }
    const dayMin = localDate.hour() * 60 + localDate.minute();
    const startDayMin = BusinessHours.hourToDayMinute(dayStart);
    const endDayMin = BusinessHours.hourToDayMinute(dayEnd);
    if (startDayMin === -1 || endDayMin === -1) {
      logger.warn({ hours, dayMin, startDayMin, endDayMin }, `BUSINESS HOURS(${localDate.format()}): DAY(${localDay}): wrong day minutes => open=${defaultOpen}`);
      return { valid: false, open: defaultOpen };
    }
    const openResult = startDayMin <= dayMin && dayMin <= endDayMin;
    logger.info(
      { hours, dayMin, startDayMin, endDayMin },
      `BUSINESS HOURS(${localDate.format()}): DAY(${localDay}): MIN(${startDayMin}<=${dayMin}<=${endDayMin}) => open=${openResult}`,
    );
    return { valid: true, open: openResult };
  }
}
